import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "app-searchable-select",
  templateUrl: "./searchable-select.component.html",
  styleUrls: ["./searchable-select.component.scss"],
})
export class SearchableSelectComponent {
  @Input() placeholderText: any;
  @Input() isDisabled: any;
  @Input() options: any;
  @Input() controlName: any;
  @Output() selectValue = new EventEmitter();
  @Input() selectedValue: any = null;
  searchText = "";
  userDetails: any;

  constructor() {
    this.userDetails = JSON.parse(localStorage.getItem("permission") ?? "{}");
  }

  filteredList(filterObj: any) {
    if (filterObj && Array.isArray(filterObj)) {
      let filteredArray = filterObj;
      if (typeof this.searchText === "string") {
        filteredArray = filterObj.filter((f: any) => {
          let opt = f?.name;
          if (f?.display_name) {
            opt = f.display_name;
          }
          if (opt) {
            return (
              opt.toLowerCase().includes(this.searchText.toLowerCase())
            );
          } else {
            return false;
          }
        });
      }
      return filteredArray;
    }
    return [];
  }

  optionSelected(event: any) {
    this.selectedValue = event.option?.value;
    this.selectValue.emit(this.selectedValue);
  }

  clearField() {
    this.selectedValue = null;
    this.searchText = "";
    this.selectValue.emit(this.selectedValue);
  }

  displayNameFn(data: any) {
    // If parent component passed an array,
    // pick the last item as the current selection
    let item = data;
    if (Array.isArray(data)) {
      item = data.length ? data[data.length - 1] : null;
    }
    if (item?.display_name) {
      return item.display_name;
    }
    if (item?.name) {
      return item.name;
    }
    return "";
  }

  manipulateValue(val: any) {
    this.selectedValue = val;
    this.selectValue.emit(this.selectedValue);
  }

  manipulateValueWithoutEmitting(val: any) {
    this.selectedValue = val;
    this.searchText = val;
  }
}
